export function formatBytes(n?: number): string {
  if (n === undefined || !Number.isFinite(n)) return '–';
  const u = ['B', 'kB', 'MB', 'GB', 'TB'];
  let i = 0;
  let v = n;
  while (v >= 1000 && i < u.length - 1) {
    v /= 1000;
    i++;
  }
  return `${v.toLocaleString('nb-NO', { maximumFractionDigits: v < 10 && i > 0 ? 1 : 0 })} ${u[i]}`;
}

export function formatCount(n: number): string {
  if (n >= 1e6) return `${(n / 1e6).toLocaleString('nb-NO', { maximumFractionDigits: 1 })} mill.`;
  if (n >= 1e4) return `${Math.round(n / 1e3).toLocaleString('nb-NO')}k`;
  return n.toLocaleString('nb-NO');
}

export function formatCoord(v: number, decimals = 2): string {
  return v.toLocaleString('nb-NO', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

/** Naturlig sortering: cloud2 < cloud10 */
export function naturalCompare(a: string, b: string): number {
  return a.localeCompare(b, 'nb', { numeric: true, sensitivity: 'base' });
}

export const CRS_NAMES: Record<string, string> = {
  'EPSG:25832': 'ETRS89 / UTM sone 32N',
  'EPSG:25833': 'ETRS89 / UTM sone 33N',
  'EPSG:25835': 'ETRS89 / UTM sone 35N',
  NN2000: 'NN2000 høyde (EPSG:5941)',
  'EPSG:5941': 'NN2000 høyde',
};

export function el<K extends keyof HTMLElementTagNameMap>(tag: K, props: Record<string, unknown> = {}, ...children: (Node | string | null | undefined)[]): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(props)) {
    if (v === undefined || v === null || v === false) continue;
    if (k === 'class') e.className = String(v);
    else if (k.startsWith('on') && typeof v === 'function') e.addEventListener(k.slice(2), v as EventListener);
    else if (k in e && k !== 'list') (e as unknown as Record<string, unknown>)[k] = v;
    else e.setAttribute(k, String(v));
  }
  for (const c of children) if (c !== null && c !== undefined) e.append(c);
  return e;
}
